<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ title }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral" @click="cancel">Cancel</base-button>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-body>
          <b-form @submit.prevent="submit">
            <b-row>
              <b-col md="6">
                <base-input label="Name" name="Name" placeholder="Name" v-model="form.name" rules="required" />
              </b-col>
              <b-col md="6" v-if="members.length > 0">
                <label class="form-control-label">Competition Type</label>
                <div class="w-100">
                  <el-select
                    class="select-primary w-100"
                    v-model="form.type"
                    placeholder="Competition Type"
                    name="Competition Type"
                    rules="required"
                  >
                    <el-option
                      class="select-primary"
                      v-for="type in types"
                      :key="type.value"
                      :label="type.label"
                      :value="type.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-4">
              <b-col md="6">
                <label class="form-control-label">Competition Based On</label>
                <div class="w-100">
                  <el-select
                    class="select-primary w-100"
                    v-model="form.based_on"
                    placeholder="ClarityNOW Section"
                    name="ClarityNOW Section"
                    rules="required"
                    v-if="form.type == 'team'"
                  >
                    <el-option
                      class="select-primary"
                      v-for="section in sections"
                      :key="section.value"
                      :label="section.label"
                      :value="section.value"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    class="select-primary w-100"
                    v-model="form.based_on"
                    placeholder="ClarityNOW Section"
                    name="ClarityNOW Section"
                    rules="required"
                    v-else
                  >
                    <el-option
                      class="select-primary"
                      v-for="source in trackingSources"
                      :key="source.id"
                      :label="source.name"
                      :value="source.slug"
                    >
                    </el-option>
                  </el-select>
                </div>
              </b-col>
              <b-col md="6">
                <label class="form-control-label">Competitors</label>
                <div class="w-100">
                  <el-select
                    class="select-primary w-100"
                    v-model="form.competitors"
                    placeholder="Competitors"
                    name="Competitors"
                    rules="required"
                    tags
                    multiple
                  >
                    <el-option
                      class="select-primary"
                      v-for="competitor in competitors"
                      :key="competitor.id"
                      :label="competitor.name"
                      :value="competitor.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <base-input label="Short Description" name="Short Description" placeholder="Short Description" v-model="form.short_desc" rules="required" />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <base-input label="Description" label-for="description" rules="required" name="Description">
                  <html-editor v-model="form.description" placeholder="Type in a short description of what the competition is about."></html-editor>
                </base-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <base-input name="Start Date" rules="required" type="date" label="Start Date" placeholder="Start Date" label-for="start_date" v-model="form.start_date" />
              </b-col>
              <b-col md="4">
                <base-input name="End Date" rules="required" type="date" label="End Date" placeholder="End Date" label-for="start_date" v-model="form.end_date" />
              </b-col>
              <b-col md="4">
                <base-input label="Active" label-for="active">
                  <base-switch class="mr-1" v-model="form.active"></base-switch>
                </base-input>
              </b-col>
            </b-row>
            <b-row class="mt-5">
              <b-col class="text-center">
                <base-button type="success" native-type="submit">Submit</base-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import {Select, Option} from 'element-ui';
import HtmlEditor from '@/components/Inputs/HtmlEditor';

export default {
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    HtmlEditor
  },
  data() {
    return {
      form: {
        name: '',
        type: 'team',
        description: '',
        short_desc: '',
        based_on: '',
        start_date: '',
        end_date: '',
        active: false,
        competitors: []
      },
      sections: [
        { value: "hours", label: "Hours Lead Generated" },
        { value: "dials", label: "Dials Made" },
        { value: "contacts", label: "Contacts Made" },
        { value: "listing_nurtures", label: "Listings Nurtured" },
        { value: "listings_set", label: "Listing Appointments Set" },
        { value: "listings_held", label: "Listing Appointments Held" },
        { value: "listings_taken", label: "Listings Taken" },
        { value: "listings_sold", label: "Listings Sold" },
        { value: "buyer_nurtures", label: "Buyers Nurtured" },
        { value: "buyers_set", label: "Buyer Appointments Set" },
        { value: "buyers_held", label: "Buyer Appointments Held" },
        { value: "buyers_signed", label: "Buyers Signed" },
        { value: "buyers_sold", label: "Buyers Sold" },
        { value: "price_correction", label: "Price Corrections" },
        { value: "offers_written", label: "Offers Written" },
      ],
      types: [
        { value: "team", label: "Team" },
        { value: "community", label: "Community" }
      ],
      community: null,
      members: [],
      agents: [],
      trackingSources: []
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    }),
    title() {
      return this.form.id ? "Edit Competition" : "New Competition";
    },
    competitors() {
      return this.form.type == 'team' ? this.agents : this.members;
    }
  },
  methods: {
    async getCommunity() {
      await axios.get(this.userRoute + "/get-communities")
      .then(response => {
        this.community = response.data;

        if (this.community) {
          this.getCommunityMembers();
        }
      })
      .catch(error => {
        // 
      });
    },
    async getCommunityMembers() {
      await axios.get(this.userRoute + "/community/members")
      .then(response => {
        this.members = response.data;
      })
      .catch(error => {
        // 
      });
    },
    async getTeamAgents() {
      await axios.get(this.userRoute + "/team/agents")
      .then(response => {
        this.agents = response.data;
      })
      .catch(error => {
        // 
      });
    },
    async getTrackingSources() {
      axios.get(this.userRoute + "/tracking-sources")
      .then(response => {
        response.data.forEach(source => {
          this.sections.push({
            value: source.slug,
            label: source.name
          });
        });
      })
      .catch(error => {
        this.error(error);
      })
    },
    async getCommunityTrackingSources() {
      await axios.get(this.userRoute + "/community/tracking-sources")
      .then(response => {
        this.trackingSources = response.data;
      })
      .catch(error => {
        this.error(error);
      })
    },
    async submit() {
      await axios.post(this.userRoute + "/competitions", this.form)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$router.push("/competitions");
        });
      })
      .catch(error => {
        // 
      });
    },
    cancel() {
      this.$router.push({
        path: '/competitions'
      });
    }
  },
  created() {
    this.getTeamAgents();
    this.getCommunity();
    this.getTrackingSources();
    this.getCommunityTrackingSources();
  },
  watch: {
    'form.type'(to, from) {
      if (to == 'community') {

      }
    }
  }
};
</script>